import { useLogger } from '@tumelo/logging'
import React, { createContext, ReactNode, useMemo, useEffect } from 'react'
import { useAuth, AuthResponse } from '@/application/features/auth/useAuth'
import { DefaultUser } from '@/application/Mocks/user'

const defaultAuthState: AuthResponse = {
  user: DefaultUser(),
  error: undefined,
  signOut: async () => {},
}

interface AuthProviderProps {
  children: ReactNode
}

export const UserContext = createContext<AuthResponse>(defaultAuthState)

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { user, error, signOut } = useAuth()
  const logger = useLogger()

  const value = useMemo(
    () => ({
      user,
      error,
      signOut,
    }),
    [user, error, signOut]
  )

  useEffect(() => {
    if (user.sub) {
      // useAuth returns empty user if not authenticated, so we skip if user.sub is falsy
      logger.setUserData({ id: user.sub })
    }
  }, [logger, user])

  return <UserContext value={value}>{children}</UserContext>
}
